import Typography from 'antd/lib/typography';
import { formatToMinutesAndHours } from '../../../../domain/date/date';

export const EventGridCellTooltip = ({
    eventStartTime,
    eventProgram,
    sitesCount,
    noEndTime,
    eventDuration,
    standbyPeriodDuration,
}: {
    eventStartTime: string;
    eventProgram: string;
    sitesCount: number;
    noEndTime?: boolean;
    eventDuration?: number;
    standbyPeriodDuration?: number;
}) => {
    return (
        <div style={{ fontWeight: 400 }}>
            <Typography.Paragraph>
                Start Time(s): <Typography.Text strong>{eventStartTime}</Typography.Text>
            </Typography.Paragraph>
            {eventProgram && (
                <Typography.Paragraph>
                    Programs: <Typography.Text strong>{eventProgram}</Typography.Text>
                </Typography.Paragraph>
            )}
            {standbyPeriodDuration && (
                <Typography.Paragraph>
                    Standby Period duration: <Typography.Text strong>{formatToMinutesAndHours(standbyPeriodDuration)}</Typography.Text>
                </Typography.Paragraph>
            )}
            {eventDuration && (
                <Typography.Paragraph>
                    Event(s) duration: <Typography.Text strong>{!noEndTime ? formatToMinutesAndHours(eventDuration) : 'unknown'}</Typography.Text>
                </Typography.Paragraph>
            )}
            <Typography.Text>
                Affected Site(s): <Typography.Text strong>{sitesCount}</Typography.Text>
            </Typography.Text>
        </div>
    );
};
